module.exports = __webpack_public_path__ + "img/alerta.e7354889.svg";